import he from 'he';

const heOpts = {
  allowUnsafeSymbols: true,
  strict: true,
};

export function encodeText(text) {
  return he.encode(text, {
    allowUnsafeSymbols: true,
  });
}

export function decodeText(text) {
  let retVal = text;

  try {
    let post = he.decode(retVal, heOpts);

    while (retVal !== post) {
      retVal = post;
      post = he.decode(retVal, heOpts);
    }
  } catch (e) {
    console.warn(e);
  }

  return retVal;
}